var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("FabricRangeSelector", {
        attrs: {
          type: "Double Roller Blind",
          value: _vm.selectedFabricGroup,
          v: _vm.$v.selectedFabricGroup,
          error: _vm.$v.selectedFabricGroup.$error
        },
        on: {
          "selected-fabric-group": function($event) {
            _vm.selectedFabricGroup = $event
          }
        }
      }),
      _vm._v(" "),
      _c("FabricSelector", {
        attrs: {
          fabricGroupID: _vm.selectedFirstFabricGroup,
          value: _vm.item.fabric,
          v: _vm.$v.item.fabric,
          error: _vm.$v.item.fabric.$error
        },
        on: {
          "selected-fabric": function($event) {
            _vm.selectedFirstFabric = $event
          }
        }
      }),
      _vm._v(" "),
      _c("ColorSelector", {
        attrs: {
          fabricID: _vm.selectedFirstFabric,
          value: _vm.item.color,
          v: _vm.$v.item.color,
          error: _vm.$v.item.color.$error
        },
        on: {
          "selected-color": function($event) {
            _vm.item.color = $event
          }
        }
      }),
      _vm._v(" "),
      _c("FabricSelector", {
        attrs: {
          fabricGroupID: _vm.selectedSecondFabricGroup,
          value: _vm.item.variations.secondFabric,
          v: _vm.$v.item.variations.secondFabric,
          error: _vm.$v.item.variations.secondFabric.$error
        },
        on: {
          "selected-fabric": function($event) {
            _vm.selectedSecondFabric = $event
          }
        }
      }),
      _vm._v(" "),
      _c("ColorSelector", {
        attrs: {
          fabricID: _vm.selectedSecondFabric,
          value: _vm.item.variations.secondColor,
          v: _vm.$v.item.variations.secondColor,
          error: _vm.$v.item.variations.secondColor.$error
        },
        on: {
          "selected-color": function($event) {
            _vm.item.variations.secondColor = $event
          }
        }
      }),
      _vm._v(" "),
      _c("LinkedDimensionSelector", {
        ref: "dimensionSelector",
        attrs: {
          valueName: _vm.item.name,
          valueWidth: _vm.item.width,
          valueDrop: _vm.item.drop,
          valueEasyLink: _vm.item.easyLink,
          valueEasyLinkIndividuals: _vm.item.easyLinkIndividuals,
          type: this.item.type
        },
        on: {
          "selected-option": function($event) {
            return _vm.setEasyLink($event)
          },
          "individuals-width": function($event) {
            return _vm.setIndividualwidth($event)
          },
          room: function($event) {
            return _vm.setRoom($event)
          },
          ready: function(isReady) {
            return (_vm.readyToSubmitDimension = isReady)
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Fitting",
          value: _vm.item.variations.fitting,
          options: ["Face Fit", "Recess Fit"],
          v: _vm.$v.item.variations.fitting,
          error: _vm.$v.item.variations.fitting.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.fitting = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Bracket Type",
          value: _vm.item.variations.bracketType,
          options: ["Regular Double Bracket", "Slimline Double Bracket"],
          v: _vm.$v.item.variations.bracketType,
          error: _vm.$v.item.variations.bracketType.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.bracketType = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.item.variations.bracketType === "Slimline Double Bracket",
            expression:
              "item.variations.bracketType === 'Slimline Double Bracket'"
          }
        ],
        attrs: {
          title: "Roll Direction",
          value: _vm.item.variations.rollDirection,
          options: [
            "Top Front - Front Roll & Back Roll",
            "Top Front - Both Front Roll",
            "Top Back - Front Roll & Back Roll",
            "Top Back - Both Back Roll"
          ],
          v: _vm.$v.item.variations.rollDirection,
          error: _vm.$v.item.variations.rollDirection.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.rollDirection = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.item.variations.bracketType === "Regular Double Bracket",
            expression:
              "item.variations.bracketType === 'Regular Double Bracket'"
          }
        ],
        attrs: {
          title: "Roll Direction",
          value: _vm.item.variations.rollDirection,
          options: [
            "Front Roll & Back Roll",
            "Both Back Roll",
            "Both Front Roll"
          ],
          v: _vm.$v.item.variations.rollDirection,
          error: _vm.$v.item.variations.rollDirection.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.rollDirection = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Control Type",
          value: _vm.item.variations.controlType,
          options: ["Chain", "Motor"],
          v: _vm.$v.item.variations.controlType,
          error: _vm.$v.item.variations.controlType.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.variations.controlType = $event), _vm.resetControlType()
          }
        }
      }),
      _vm._v(" "),
      _vm.item.variations.controlType === "Chain"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Chain Colour",
              value: _vm.item.variations.chainColor,
              options: [
                "Silver Metal (+$5)",
                "Black",
                "White",
                "Grey",
                "Black Nickel"
              ],
              v: _vm.$v.item.variations.chainColor,
              error: _vm.$v.item.variations.chainColor.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.chainColor = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.controlType === "Motor"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Motor",
              value: _vm.item.variations.motor,
              options: ["Battery", "Wired"],
              v: _vm.$v.item.variations.motor,
              error: _vm.$v.item.variations.motor.$error
            },
            on: {
              "selected-option": function($event) {
                ;(_vm.item.variations.motor = $event), _vm.resetMotorOptions()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.motor === "Battery"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Motor Options",
              value: _vm.item.variations.motorOption,
              options: [
                "Somfy Altus 28 1.5nm ($210)",
                "Somfy Sonesse 30 2.0nm ($295)"
              ],
              v: _vm.$v.item.variations.motorOption,
              error: _vm.$v.item.variations.motorOption.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.motorOption = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.motor === "Wired"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Motor Options",
              value: _vm.item.variations.motorOption,
              options: [
                "Somfy Altus 40mm RTS ($265)",
                "Somfy Sonesse RTS 40mm ($380)"
              ],
              v: _vm.$v.item.variations.motorOption,
              error: _vm.$v.item.variations.motorOption.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.motorOption = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.controlType === "Motor"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Remote",
              value: _vm.item.variations.remote,
              options: [
                "Situo Pure 1 channel",
                "Situo Pure 5 channel",
                "No Remote"
              ],
              v: _vm.$v.item.variations.remote,
              error: _vm.$v.item.variations.remote.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.remote = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.controlType === "Motor" &&
      _vm.item.variations.motor === "Battery"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Charger",
              value: _vm.item.variations.charger,
              options: ["Somfy Motor Charger", "No Charger"],
              v: _vm.$v.item.variations.charger
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.charger = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.controlType === "Motor"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Automation",
              value: _vm.item.variations.automation,
              options: ["Somfy Connexoon", "None"],
              v: _vm.$v.item.variations.automation
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.automation = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Bracket Colour",
          value: _vm.item.variations.bracketColor,
          options: ["Black", "White", "Grey", "Ivory"],
          v: _vm.$v.item.variations.bracketColor,
          error: _vm.$v.item.variations.bracketColor.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.bracketColor = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Base Rail Shape",
          value: _vm.item.variations.baseRailShape,
          options: ["Oval", "D30", "Heavy Duty", "Small Flat"],
          v: _vm.$v.item.variations.baseRailShape,
          error: _vm.$v.item.variations.baseRailShape.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.baseRailShape = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Base Rail Colour",
          value: _vm.item.variations.baseRailColor,
          options: [
            "Anodised Silver",
            "Dune",
            "Bronze Pearl",
            "Satin Black",
            "White",
            "Bone",
            "Sandstone"
          ],
          v: _vm.$v.item.variations.baseRailColor,
          error: _vm.$v.item.variations.baseRailColor.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.baseRailColor = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.incInstall
        ? _c(
            "div",
            [
              _c("v-checkbox", {
                attrs: { label: "Install?", color: "primary" },
                model: {
                  value: _vm.customInstall,
                  callback: function($$v) {
                    _vm.customInstall = $$v
                  },
                  expression: "customInstall"
                }
              }),
              _vm._v(" "),
              _vm.customInstall
                ? _c("v-text-field", {
                    attrs: { label: "Install Price" },
                    model: {
                      value: _vm.item.installPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "installPrice", $$v)
                      },
                      expression: "item.installPrice"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Line Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add " + _vm._s(_vm.item.type))]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          ),
      _vm._v(" "),
      _c("b", [_vm._v("$" + _vm._s(_vm.item.total.toFixed(2)))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3aac1b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3aac1b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/LinkedDoubleRollerBlind.vue
// module id = null
// module chunks = 